<template>
  <ol class="breadcrumb">
    <li class="breadcrumb-item head">
      <h1 class="page-header">{{ setHeader }}</h1>
    </li>
    <li class="breadcrumb-item">
      <router-link :to="setHomeLink"><i class="fas fa-home"></i></router-link>
    </li>
    <li
      class="breadcrumb-item"
      :class="{ active: item.path === '' }"
      v-for="(item, index) in setBreadcrumb"
      :key="index"
    >
      <span class="w-100" v-if="item.path !== ''">
        <router-link :to="item.path">{{ item.title }}</router-link>
      </span>
      <span class="w-100" v-else>
        {{ item.title }}
      </span>
    </li>

    <li class="ml-auto">
        <button
        class="btn btn-light BtnNewJSATalk"
        :ref="'btn-newJSATalk'"
        :id="'btn-newJSATalk'"
        v-show="displayJSATlak"
      >
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 16 16"><path fill="currentColor" fill-rule="evenodd" d="M4 6.5a1.5 1.5 0 1 0 0-3a1.5 1.5 0 0 0 0 3M7 5a3 3 0 0 1-.87 2.113A4 4 0 0 1 8 10.5V12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-1.5c0-1.427.747-2.679 1.87-3.387A3 3 0 1 1 7 5m8.78.28a.75.75 0 0 0-1.06-1.06L12 6.94l-1.22-1.22a.75.75 0 1 0-1.06 1.06l1.75 1.75a.75.75 0 0 0 1.06 0z" clip-rule="evenodd"/></svg>
        New JSA Talk
      </button>
      <button
        class="btn btn-light BtnSuspend"
        :ref="'btn-revalidation'"
        :id="'btn-revalidation'"
        v-show="displayRevalidation"
      >
        <i class="fas fa-ban"></i>
        {{ mLanguage.revalidation[setLanguage] }}
      </button>
      <button
        class="btn btn-light BtnSuspend"
        :ref="'btn-suspend'"
        :id="'btn-suspend'"
        v-show="displaySuspend"
      >
        <i class="fas fa-ban"></i>
        {{ mLanguage.suspend[setLanguage] }}
      </button>
      <b-button class="btn" variant="warning" v-if="ChangeNamePermit" @click="$emit('OpenmodalChangeWorker')">เปลี่ยนชื่อผู้ปฏิบัติงาน</b-button>
      <button
        class="btn btn-light BtnPrint"
        :ref="'btn-quickview'"
        :id="'btn-quickview'"
        v-show="displayQuickview"
        @click="onQuickview()"
      >
        <i class="fas fa-file-alt mx-1"></i>
        {{ mLanguage.quickview[setLanguage] }}
      </button>
      <button
        class="btn btn-light BtnPrint"
        :ref="'btn-print'"
        :id="'btn-print'"
        v-show="displayPrint"
        @click="onPrint()"
      >
        <i class="fas fa-print mx-1"> </i>
        {{ mLanguage.print[setLanguage] }}
      </button>
    </li>
    <b-modal
      id="mLoading2"
      ref="mLoading2"
      centered
      :hide-footer="true"
      :hide-header="true"
      :no-fade="true"
      :no-close-on-backdrop="true"
    >
      <div class="text-center">
        <div class="loader">Loading...</div>
      </div>
    </b-modal>
  </ol>
</template>

<script>
/* eslint-disable */
import HelpFunc from "../../Helper/funcHelper";
import mLanguage from "../../config/MasterLanguage.vue";
import Apiservice from "../../service/Service";

export default {
  props: ["headerdata", "PermitStatus", "onDisableForm", "permissionAction"],
  data() {
    return {
      mLanguage: mLanguage,
    };
  },
  computed: {
    setLanguage() {
      return this.$store.state.language === 0 ? "title_th" : "title";
    },
    setHeader() {
      return HelpFunc.checkEmptyData(this.headerdata.header) === true
        ? "No Header"
        : this.headerdata.header;
    },
    setHomeLink() {
      return HelpFunc.checkEmptyData(this.headerdata.homelink) === true
        ? "/"
        : this.headerdata.homelink;
    },
    setBreadcrumb() {
      return HelpFunc.checkEmptyData(this.headerdata.breadcrumb) === true
        ? []
        : this.headerdata.breadcrumb;
    },
    ChangeNamePermit() {
      return this.headerdata.ChangeNamePermit ? true : false;
    },
    displayQuickview() {
      return HelpFunc.checkEmptyData(this.headerdata.quickview) === true
        ? false
        : this.headerdata.quickview;
    },
    displayPrint() {
      return HelpFunc.checkEmptyData(this.headerdata.print) === true
        ? false
        : this.headerdata.print;
    },
    displaySuspend() {
      return HelpFunc.checkEmptyData(this.headerdata.suspend) === true
        ? false
        : this.headerdata.suspend;
    },
    displayRevalidation() {
      return HelpFunc.checkEmptyData(this.headerdata.revalidation) === true
        ? false
        : this.headerdata.revalidation;
    },
    displayJSATlak(){
        return HelpFunc.checkEmptyData(this.headerdata.jsaTlak) === true
        ? false
        : (this.PermitStatus != 13 && this.PermitStatus != 14 && !this.onDisableForm && this.permissionAction) ? true : false  
    }
  },
  created() {
    this.getLink();
  },
  methods: {
    getLink() {},
    loadingPage(val) {
      if (typeof val === "undefined") {
        this.$refs["mLoading2"].toggle("#toggle-btn");
      } else {
        if (val === "show") {
          this.$refs["mLoading2"].show();
        } else {
          this.$refs["mLoading2"].hide();
        }
      }
    },
    onQuickview() {
      let tempURL = "/Section1/Request-7";
      const tempParam = this.$route.params.reqID;
      let newWin = window.open(tempURL + "/" + tempParam, "_blank");
      // newWin.addEventListener("load", ()=> {
      // 	newWin.document.title = document.title;
      // });
    },
    onPrint() {
      this.loadingPage("show");

      let ReqID = this.$parent.$parent.getpathNewTabID();

      const step1 = () => {
          Apiservice.onStep1_Get(
            {
              SessionEmpID: this.UserPropEmpID,
              ResponseID: 0,
              Module: "GetStepOneByItem",
              body: {
                Id: String(ReqID),
                // Id: String(this.$store.state.page.id)
              },
            },
            (res) => {
              if (res === null || res === "") {
                this.onAlert("onPrint_ePermit", "Error not found.", null); // title, msg, func
              }
              if (res.data.Status === true) {
                if (res.data.body.length !== 0) {
                  const tmpData = res.data.body[0];
                  if (tmpData.PermitNo == null) {
                    tmpData.PermitNo = "Draftfile";
                  }
                  loadPDF(tmpData.PermitNo);
                }
              } else {
                this.onAlert("onPrint_ePermit", res.data.ErrorMessage, null); // title, msg, func
              }
            }
          );
        },
        loadPDF = (pdfName) => {
          Apiservice.onPrint_ePermit(
            {
              SessionEmpID: this.UserPropEmpID,
              ResponseID: 0,
              body: {
                ReqId: String(ReqID),
                // ReqId: String(this.$store.state.page.id)
              },
            },
            (res) => {
              this.loadingPage("hide");
              if (res === null || res === "") {
                this.onAlert("onPrint_ePermit", "Error not found.", null); // title, msg, func
              } else {
                const linkSource = `data:application/octet-stream;base64,${res.data}`;
                const downloadLink = document.createElement("a");
                document.body.appendChild(downloadLink);
                downloadLink.href = linkSource;
                downloadLink.target = "_self";
                downloadLink.download = pdfName + ".pdf";
                downloadLink.click();
              }
            }
          );
        };
      step1();
    },
  },
};
</script>

<style scoped></style>
